<script>
import Spinner from "../../components/Spinner"
import Ajouter from "../../components/PageForm"
import Section from "../../components/PageSection"
import FraisLine from "../../components/projets/Notes de frais/fraisLine"

import {updateMontant} from '../../mixins/updateMontant.js';

export default {
  name: 'menu3',
  components: {
    Spinner,
    Ajouter,
    Section,
    FraisLine,
  },
  data(){
    return{
      phases: [],
      users: [],
      frais: [],
      ndfs: [],
      fullyLoaded: false
    }
  },
  mixins:[
    updateMontant,
  ],
  async mounted(){
    //Chargement des phases du projet 
    const promisePhases = this.$axios.get('phases/getByProjet/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.phases = response.data;
    })
    .catch(err => console.log (err.message))

    //Chargement des types de frais paramétrés par l'agence
    const promiseFrais = this.$axios.get('frais/unflagged/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.frais = response.data;
    })
    .catch(err => console.log (err.message))

    //Chargement des frais existants pour ce projet
    const promiseNotesDeFrais = this.$axios.get('ndf/getByProjet/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.ndfs = response.data;
    })
    .catch(err => console.log (err.message))

    await Promise.all([promisePhases, promiseFrais, promiseNotesDeFrais])
    this.fullyLoaded = true;
  },
  methods:{
    //Ajouter une nouvelle note de frais
    ajouter(payload){
      let newFrais = {}

      //Initialisation de la nouvelle note de frais
      newFrais = {
        agenceId  : this.$store.state.auth.currentAgence._id,
        labelId   : this.frais[0]._id,
        phaseId   : payload[0],
        objet     : "",
        montantHT : 0,
        date      : new Date(),
      }

      //Envoi au serveur
      this.$axios.post('ndf/register', newFrais)
      .then(response => {
        //Ajout de l'id de l'objet nouvellement créé par le serveur pour pouvoir manipuler l'objet depuis le client
        newFrais._id = response.data.ndfId
        newFrais.date = response.data.date
        newFrais.phaseName = this.phases.find(x => (x._id == newFrais.phaseId)).name
        this.ndfs.unshift(newFrais)
      })
      .catch(err => console.log(err.message))
    },

    //Modifier une note de frais
    modifier(evt){
      this.$axios.put('ndf/'+ evt._id, evt)
      .then(response => {
        console.log(response.data.message)
        //Modification dans le client
        //Merge le nouvel item au premier
        let newItem = {...this.ndfs.find(e => (e._id == evt._id)), ...evt}
        //Le remplacer dans la tableau du client
        this.ndfs.splice(this.ndfs.findIndex(e => (e._id == evt._id)), 1, newItem)

      })
      .catch(err => console.log(err.message))
    },

    //Supprimer une note de frais
    deleteFrais(evt){
      this.$axios.delete('ndf/' + evt)
        .then(response => {
            console.log(response.data.message);
            
            //Si suppression ok sur le server, suppression sur le client.
            const index = this.ndfs.findIndex(e => e._id === evt);
            if( index >= 0 ){
                this.ndfs.splice(index, 1);
            } else {
                console.log("_id non reconnue sur le client, mais suppression effective sur le server.");
            }
        })
        .catch(err => {
            console.log(err)
        });
    },

    infosTotalHT(){
      let valeur = "0 000"
      valeur = this.ndfs.reduce((a, b) => a + (b['montantHT'] || 0), 0);
      valeur = Math.round(valeur * 100) / 100
      return this.updateMontant(valeur).str
    },
  }
}
</script>


<template>
    <Spinner v-if="!fullyLoaded"/>
    <div v-else class="NotesDeFraisMain">
      
      <Ajouter class="ajouter" label="Ajouter une note de frais" text="Ajouter" @submit="ajouter($event)">
        <template v-slot:body>
          <select class="ajouter__input" required placeholder="Phase">
            <option value="">Sélectionner la phase</option>
            <option v-for="phase in phases" :key="phase._id" :value="phase._id" > {{phase.name}} </option>
            <!-- <option v-if="phasesLabelsBy(0).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(0)" :key="phaseLabel._id" :value="{type:0, _id:phaseLabel._id}">{{ phaseLabel.name }}</option>
            <option v-if="phasesLabelsBy(1).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(1)" :key="phaseLabel._id" :value="{type:1, _id:phaseLabel._id}">{{ phaseLabel.name }}</option>
            <option v-if="phasesLabelsBy(2).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(2)" :key="phaseLabel._id" :value="{type:2, _id:phaseLabel._id}">{{ phaseLabel.name }}</option> -->
          </select>
        </template>
      </Ajouter>
      
      <!-- Demain, une section par phase où il y a une notes de frais. Cela permettra d'alléger la barre fraisLine en enlevant la mention de la phase. -->
      <div v-if="ndfs.length == 0" class="empty">Il n'y a encore aucune note de frais pour ce projet.</div>
      <Section v-else text="" class="sectionPhases">
        <template v-slot:body>
          <FraisLine v-for="item in ndfs" :key="item._id" :ndfId="item._id" :nomPhase="phases.find(e => (e._id == item.phaseId)).name" :date="item.date" :labelId="item.labelId" :frais="frais" :objet="item.objet" :montantHT="item.montantHT" @update="modifier($event)" @suppr="deleteFrais($event)"/>
        </template>
      </Section> 

      <Section text="Total" underlined="true" class="sectionInfos">
        <template v-slot:body>
          <div class="sectionInfos__line">
            <div>Total HT :</div><div> {{infosTotalHT()}} €</div>
          </div>
        </template>
      </Section>

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.NotesDeFraisMain{
  @include grid-alpha-noFirst;
}

.ajouter{
  grid-column: 1 / span 2;

  &__input{
    background-color: $black-lighter;
    border: none;
    width: 200px;
    color: $black-bolder;
  }
}

.empty{
  grid-column: 1 / span 2;
  @include myFont;
  font-size: 12px;
  color: $black;
}

.sectionPhases{
  grid-column: 1 / span 2;
}

.sectionInfos{
grid-column: 3;
grid-row: 1;

  &__line{
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include myFont;
    font-size: 13px;
    margin: 5px 0 0 0;
    color: $black-bolder;
    
    & > input{
      border-width: 0 0 1px 0;
      border-color: $main;
      background-color: $black-lighter;
    }

    &__date{
      margin: 0 10px 0 0;
      font-size: 13px;
    }

    &__blank{
      flex: 1;
    }

    &__euros{
      margin: 0 10px 0 10px;
    }

    &__noDelete{
      width: 20px;
    }

    &__icon{
      color: $black-bolder;
      font-size: 20px;
      // margin: 0 0 0 7px;
    }

    &__add{
      @include myFont;
      font-size: 13px;
      margin: 15px 0 0 0;
      color: $black-bolder;
      display: flex;
      align-items: center;

      & > .material-icons{
        color: $main;
        margin: 0 5px 0 0;
      }

      &:hover{
        color: $color2;
        cursor: pointer;

        & .sectionInfos__line__add__icon{
          color: $color2;
        }
      }

    }
  }
}

.modale{
  &__grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px
  }

  &__input{
    @include myFont;
  }
}

</style>